// Create types
export const AGREEMENT_CREATE_ERROR = 'AGREEMENT_CREATE_ERROR';
export const AGREEMENT_CREATE_LOADING = 'AGREEMENT_CREATE_LOADING';
export const AGREEMENT_CREATE_SUCCESS = 'AGREEMENT_CREATE_SUCCESS';
export const AGREEMENT_CREATE_VIOLATIONS = 'AGREEMENT_CREATE_VIOLATIONS';
export const AGREEMENT_CREATE_RESET = 'AGREEMENT_CREATE_RESET';

// Show types
export const AGREEMENT_SHOW_ERROR = 'AGREEMENT_SHOW_ERROR';
export const AGREEMENT_SHOW_LOADING = 'AGREEMENT_SHOW_LOADING';
export const AGREEMENT_SHOW_RETRIEVED_SUCCESS = 'AGREEMENT_SHOW_RETRIEVED_SUCCESS';
export const AGREEMENT_SHOW_RESET = 'AGREEMENT_SHOW_RESET';

// Update types
export const AGREEMENT_UPDATE_RESET = 'AGREEMENT_UPDATE_RESET';
export const AGREEMENT_UPDATE_UPDATE_ERROR = 'AGREEMENT_UPDATE_UPDATE_ERROR';
export const AGREEMENT_UPDATE_UPDATE_LOADING = 'AGREEMENT_UPDATE_UPDATE_LOADING';
export const AGREEMENT_UPDATE_UPDATE_SUCCESS = 'AGREEMENT_UPDATE_UPDATE_SUCCESS';
export const AGREEMENT_UPDATE_RETRIEVE_ERROR = 'AGREEMENT_UPDATE_RETRIEVE_ERROR';
export const AGREEMENT_UPDATE_RETRIEVE_LOADING = 'AGREEMENT_UPDATE_RETRIEVE_LOADING';
export const AGREEMENT_UPDATE_RETRIEVE_SUCCESS = 'AGREEMENT_UPDATE_RETRIEVE_SUCCESS';
export const AGREEMENT_UPDATE_UPDATE_VIOLATIONS = 'AGREEMENT_UPDATE_UPDATE_VIOLATIONS';

// Delete types
export const AGREEMENT_DELETE_ERROR = 'AGREEMENT_DELETE_ERROR';
export const AGREEMENT_DELETE_LOADING = 'AGREEMENT_DELETE_LOADING';
export const AGREEMENT_DELETE_SUCCESS = 'AGREEMENT_DELETE_SUCCESS';
export const AGREEMENT_DELETE_RESET = 'AGREEMENT_DELETE_RESET';

// List types
export const AGREEMENT_LIST_ERROR = 'AGREEMENT_LIST_ERROR';
export const AGREEMENT_LIST_LOADING = 'AGREEMENT_LIST_LOADING';
export const AGREEMENT_LIST_RESET = 'AGREEMENT_LIST_RESET';
export const AGREEMENT_LIST_PAGINATION = 'AGREEMENT_LIST_PAGINATION';
export const AGREEMENT_LIST_SUCCESS = 'AGREEMENT_LIST_SUCCESS';
export const AGREEMENT_LIST_ORDER = 'AGREEMENT_LIST_ORDER';
export const AGREEMENT_LIST_PAGE = 'AGREEMENT_LIST_PAGE';

// customer List
export const AGREEMENT_CUSTOMER_ERROR = 'AGREEMENT_CUSTOMER_ERROR';
export const AGREEMENT_CUSTOMER_LOADING = 'AGREEMENT_CUSTOMER_LOADING';
export const AGREEMENT_CUSTOMER_SUCCESS = 'AGREEMENT_CUSTOMER_SUCCESS';

// invoice List
export const AGREEMENT_INVOICE_ERROR = 'AGREEMENT_INVOICE_ERROR';
export const AGREEMENT_INVOICE_LOADING = 'AGREEMENT_INVOICE_LOADING';
export const AGREEMENT_INVOICE_SUCCESS = 'AGREEMENT_INVOICE_SUCCESS';
export const AGREEMENT_INVOICE_RESET = 'AGREEMENT_INVOICE_RESET';

// invoice to deduction
export const AGREEMENT_INVOICE_TO_DEDUCTION_ERROR = 'AGREEMENT_INVOICE_TO_DEDUCTION_ERROR';
export const AGREEMENT_INVOICE_TO_DEDUCTION_LOADING = 'AGREEMENT_INVOICE_TO_DEDUCTION_LOADING';
export const AGREEMENT_INVOICE_TO_DEDUCTION_SUCCESS = 'AGREEMENT_INVOICE_TO_DEDUCTION_SUCCESS';
export const AGREEMENT_INVOICE_TO_DEDUCTION_RESET = 'AGREEMENT_INVOICE_TO_DEDUCTION_RESET';

// invoice to refund
export const AGREEMENT_INVOICE_TO_REFUND_ERROR = 'AGREEMENT_INVOICE_TO_REFUND_ERROR';
export const AGREEMENT_INVOICE_TO_REFUND_LOADING = 'AGREEMENT_INVOICE_TO_REFUND_LOADING';
export const AGREEMENT_INVOICE_TO_REFUND_SUCCESS = 'AGREEMENT_INVOICE_TO_REFUND_SUCCESS';
export const AGREEMENT_INVOICE_TO_REFUND_RESET = 'AGREEMENT_INVOICE_TO_REFUND_RESET'

// document
export const AGREEMENT_DOCUMENT_ERROR = 'AGREEMENT_DOCUMENT_ERROR';
export const AGREEMENT_DOCUMENT_LOADING = 'AGREEMENT_DOCUMENT_LOADING';
export const AGREEMENT_DOCUMENT_SUCCESS = 'AGREEMENT_DOCUMENT_SUCCESS';

// document List
export const AGREEMENT_DOCUMENT_LIST_ERROR =   'AGREEMENT_DOCUMENT_LIST_ERROR';
export const AGREEMENT_DOCUMENT_LIST_LOADING = 'AGREEMENT_DOCUMENT_LIST_LOADING';
export const AGREEMENT_DOCUMENT_LIST_SUCCESS = 'AGREEMENT_DOCUMENT_LIST_SUCCESS';

// document
export const AGREEMENT_SETTLEMENT_ERROR = 'AGREEMENT_SETTLEMENT_ERROR';
export const AGREEMENT_SETTLEMENT_LOADING = 'AGREEMENT_SETTLEMENT_LOADING';
export const AGREEMENT_SETTLEMENT_SUCCESS = 'AGREEMENT_SETTLEMENT_SUCCESS';

// document List
export const AGREEMENT_SETTLEMENT_LIST_ERROR =   'AGREEMENT_SETTLEMENT_LIST_ERROR';
export const AGREEMENT_SETTLEMENT_LIST_LOADING = 'AGREEMENT_SETTLEMENT_LIST_LOADING';
export const AGREEMENT_SETTLEMENT_LIST_SUCCESS = 'AGREEMENT_SETTLEMENT_LIST_SUCCESS';


// WEBPACK FOOTER //
// ./src/store/modules/agreement/mutation-types.js